import { Model } from "@interfaces/model.interface";

export interface ClientContact extends Model {
	clientId: number;
	contactEmailAddress: string;
	contactName: string;
	displayName: string;
	jobTitle: string;
}

export class ClientContact implements ClientContact {
	contactEmailAddress = "";
	contactName = "";
	jobTitle = "";

	constructor(data?: Partial<ClientContact>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}